import React from 'react';

import { Product } from '@shopify-multiseller/graphql/partner/types';
import { SectionCard } from '../../../components/SectionCard';
import ProductImageManager from '../../../components/ProductImage/ProductImageManager';

export interface IProductImagesSectionProps {
    product?: Product | null;
    disabled?: boolean;
}

export const ProductImagesSection: React.FC<IProductImagesSectionProps> = ({ disabled = false }) => {
    return (
        <SectionCard
            title="Images"
            // The grid already treats the first image differently, but nothing
            // said so — the rule that decides what the shop sees was left to be
            // inferred from the layout.
            trailing={disabled ? undefined : 'First image is the cover · drag to reorder'}
            testId="product-images-section"
        >
            <ProductImageManager disabled={disabled} />
        </SectionCard>
    );
}
